import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';

/** 詳情分頁內唯讀 DetailTable（欄寬可拖曳）。 */
const FmsReadonlyTable = ({
  rows = [],
  columns,
  rowIdPrefix,
  emptyText = '尚無資料',
}) => {
  const tableRows = useMemo(
    () => (rows ?? []).map((row, index) => ({
      ...row,
      id: String(row?.id ?? `${rowIdPrefix}-${index}`),
    })),
    [rows, rowIdPrefix],
  );
  const detailTableState = useDetailTable(tableRows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  if (tableRows.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">{emptyText}</p>;
  }

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

FmsReadonlyTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowIdPrefix: PropTypes.string.isRequired,
  emptyText: PropTypes.string,
};

export default FmsReadonlyTable;
